import { passwordResetEmailFormSchema } from "@/features/authenticate/schemas/passwordResetEmailForm";
import type { PasswordResetEmailForm as PasswordResetEmailFormType } from "@/features/authenticate/types/passwordResetEmailForm";
import {
	Button,
	Image,
	Stack,
	Text,
	TextInput,
	Title,
	useMantineTheme,
} from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { Link } from "@tanstack/react-router";
import { FormLayout } from "../common/FormLayout";

export const PasswordResetEmailForm = () => {
	const theme = useMantineTheme();

	const form = useForm<PasswordResetEmailFormType>({
		mode: "uncontrolled",
		initialValues: {
			email: "",
		},
		validate: zodResolver(passwordResetEmailFormSchema),
	});

	const handleSubmit = (values: PasswordResetEmailFormType) => {
		alert(JSON.stringify(values));
	};

	return (
		<FormLayout>
			<Stack w={162} h={30} align="center" justify="center" mx="auto">
				<Image src="/Logo.png" alt="logo" />
			</Stack>
			<Title order={2} style={{ textAlign: "center" }}>
				パスワード再設定
			</Title>
			<form onSubmit={form.onSubmit(handleSubmit)}>
				<Stack gap="md">
					<Text style={{ textAlign: "left" }}>
						ご指定のメールアドレス宛にパスワード再発
						<br />
						行メールを送信します。
					</Text>
					<TextInput
						size="md"
						key={form.key("email")}
						{...form.getInputProps("email")}
						placeholder="メールアドレス"
					/>
					<Button type="submit" fullWidth size="md">
						<Text>メールを送信</Text>
					</Button>
					<Text
						component={Link}
						to="/login"
						style={{ color: theme.colors.primary[6] }}
					>
						ログイン画面に戻る
					</Text>
				</Stack>
			</form>
		</FormLayout>
	);
};
